const styObj = {
  default: {
    '--page-color01': '#f0f1f2',
    '--page-color02': '#f9fafa',
    '--page-color03': '#e3e4e5',
    '--page-color04': '#5f656a',
    '--page-color05': '#202326',
    '--page-color06': '#0c0e11',
    '--page-color07': '#f9fafa',
    '--page-color08': '#e3e4e5',
    '--page-color09': '#353a3f',
    '--page-color10': '#202326',
    '--page-color11': '#ffa433',
    '--page-color12': '#733406',
    '--page-color13': '#e3e4e5',
    '--page-color14': '#5f656a',
    '--page-color15': '#fafafa',
    '--page-color16': '#f9fafa',
    '--page-color17': '#ffa433',
    '--page-color18': '#202326',
    '--page-color19': '#ffa433',
    '--page-color20': '#733406',
    '--page-color21': '#f0f1f2',
    '--page-color22': '#8e9092',
    '--page-color23': '#f0f1f2',
    '--page-color24': '#5f656a',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#a4a5a8',
    '--page-color27': '#f9fafa',
    '--page-color28': '#e3e4e5',
    '--page-color29': '#353a3f',
    '--page-color30': '#202326',
    '--page-color31': '#ffa433',
    '--page-color32': '#733406',
    '--page-color33': '#fff4d6',
    '--page-color34': '#ffa433',
    '--page-color35': 'rgba(0, 0, 0, 0.6)',
    '--page-color36': '#fafafa',
    '--page-color37': '#202326',
    '--page-color38': '#5f656a',
    '--page-color39': '#0c0e11',
    '--page-color40': '#fafafa',
    '--page-radius1': '30px',
    '--page-radius2': '33px',
    '--page-radius3': '8px',
    '--page-radius4': '16px',
    '--page-radius5': '48px',
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
    '--back-arrow': `url(${require('@/assets/packageAssets/common/arrow01.png')})`
  },
  joyu: {
    '--page-color01': '#f0f1f2',
    '--page-color02': '#f9fafa',
    '--page-color03': '#e3e4e5',
    '--page-color04': '#5f656a',
    '--page-color05': '#202326',
    '--page-color06': '#0c0e11',
    '--page-color07': '#f9fafa',
    '--page-color08': '#e3e4e5',
    '--page-color09': '#353a3f',
    '--page-color10': '#202326',
    '--page-color11': '#FF6A55',
    '--page-color12': '#102006',
    '--page-color13': '#e3e4e5',
    '--page-color14': '#5f656a',
    '--page-color15': '#fafafa',
    '--page-color16': '#f9fafa',
    '--page-color17': '#ffa433',
    '--page-color18': '#202326',
    '--page-color19': '#FF6A55',
    '--page-color20': '#102006',
    '--page-color21': '#f0f1f2',
    '--page-color22': '#8e9092',
    '--page-color23': '#f0f1f2',
    '--page-color24': '#5f656a',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#a4a5a8',
    '--page-color27': '#f9fafa',
    '--page-color28': '#e3e4e5',
    '--page-color29': '#353a3f',
    '--page-color30': '#202326',
    '--page-color31': '#FF6A55',
    '--page-color32': '#102006',
    '--page-color33': '#FFECDD',
    '--page-color34': '#FF6A55',
    '--page-color35': 'rgba(0, 0, 0, 0.6)',
    '--page-color36': '#fafafa',
    '--page-color37': '#202326',
    '--page-color38': '#5f656a',
    '--page-color39': '#0c0e11',
    '--page-color40': '#fafafa',
    '--page-radius1': '4px',
    '--page-radius2': '4px',
    '--page-radius3': '4px',
    '--page-radius4': '4px',
    '--page-radius5': '4px',
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
    '--back-arrow': `url(${require('@/assets/packageAssets/common/arrow01.png')})`
  },
  vibeo: {
    '--page-color01': '#f0f1f2',
    '--page-color02': '#f9fafa',
    '--page-color03': '#e3e4e5',
    '--page-color04': '#5f656a',
    '--page-color05': '#202326',
    '--page-color06': '#0c0e11',
    '--page-color07': '#f9fafa',
    '--page-color08': '#e3e4e5',
    '--page-color09': '#353a3f',
    '--page-color10': '#202326',
    '--page-color11': '#ffa433',
    '--page-color12': '#733406',
    '--page-color13': '#e3e4e5',
    '--page-color14': '#5f656a',
    '--page-color15': '#fafafa',
    '--page-color16': '#f9fafa',
    '--page-color17': '#ffa433',
    '--page-color18': '#202326',
    '--page-color19': '#ffa433',
    '--page-color20': '#733406',
    '--page-color21': '#f0f1f2',
    '--page-color22': '#8e9092',
    '--page-color23': '#f0f1f2',
    '--page-color24': '#5f656a',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#a4a5a8',
    '--page-color27': '#f9fafa',
    '--page-color28': '#e3e4e5',
    '--page-color29': '#353a3f',
    '--page-color30': '#202326',
    '--page-color31': '#ffa433',
    '--page-color32': '#733406',
    '--page-color33': '#fff4d6',
    '--page-color34': '#ffa433',
    '--page-color35': 'rgba(0, 0, 0, 0.6)',
    '--page-color36': '#fafafa',
    '--page-color37': '#202326',
    '--page-color38': '#5f656a',
    '--page-color39': '#0c0e11',
    '--page-color40': '#fafafa',
    '--page-radius1': '30px',
    '--page-radius2': '33px',
    '--page-radius3': '8px',
    '--page-radius4': '16px',
    '--page-radius5': '48px',
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
    '--back-arrow': `url(${require('@/assets/packageAssets/common/arrow09.png')})`
  },
  whonow: {
    '--page-color01': '#f0f1f2',
    '--page-color02': '#f9fafa',
    '--page-color03': '#e3e4e5',
    '--page-color04': '#5f656a',
    '--page-color05': '#202326',
    '--page-color06': '#0c0e11',
    '--page-color07': '#f9fafa',
    '--page-color08': '#e3e4e5',
    '--page-color09': '#353a3f',
    '--page-color10': '#202326',
    '--page-color11': '#B9E86F',
    '--page-color12': '#102006',
    '--page-color13': '#e3e4e5',
    '--page-color14': '#5f656a',
    '--page-color15': '#fafafa',
    '--page-color16': '#f9fafa',
    '--page-color17': '#ffa433',
    '--page-color18': '#202326',
    '--page-color19': '#B9E86F',
    '--page-color20': '#102006',
    '--page-color21': '#f0f1f2',
    '--page-color22': '#8e9092',
    '--page-color23': '#f0f1f2',
    '--page-color24': '#5f656a',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#a4a5a8',
    '--page-color27': '#f9fafa',
    '--page-color28': '#e3e4e5',
    '--page-color29': '#353a3f',
    '--page-color30': '#202326',
    '--page-color31': '#B9E86F',
    '--page-color32': '#102006',
    '--page-color33': '#FFF4D6',
    '--page-color34': '#9FD957',
    '--page-color35': 'rgba(0, 0, 0, 0.6)',
    '--page-color36': '#fafafa',
    '--page-color37': '#202326',
    '--page-color38': '#5f656a',
    '--page-color39': '#0c0e11',
    '--page-color40': '#fafafa',
    '--page-radius1': '30px',
    '--page-radius2': '33px',
    '--page-radius3': '8px',
    '--page-radius4': '16px',
    '--page-radius5': '48px',
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/time.png')})`,
    '--icon-details': `url(${require('@/assets/packageAssets/views/P1_Boys/MyProps/default/details.png')})`,
    '--back-arrow': `url(${require('@/assets/packageAssets/common/arrow01.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
